export default {
  mytopic_my_reply: '我的回帖',
  mytopic_my_collect: '我的收藏',
  mytopic_post_manage: '我下架的帖子',
  mytopic_comment_manage: '我下架的評論和回復',
  mytopic_cancel_collect: '取消收藏',
  mytopic_comfirm_collect: '確認取消收藏?',
  mytopic_restore_success: '恢復上架成功',
  mytopic_restore_failed: '恢復上架失敗',
  mytopic_resume: "恢復上架",
  mytopic_confirm_resume: "確認恢復上架嗎？",
  mytopic_make_comment: '評論:',
  mytopic_make_collect: '收藏:',
  mytopic_make_like: '點贊：',
  mytopic_del_failed: '刪除失敗',
  mytopic_confirm_del_now: '確認立即刪除？',
  mytopic_del_success: '刪除成功',
}
